import http from '../../helpers/http';
import {ValidatorError} from '../../hooks/templateHooks/useServerErrorValidation'

export const DesencryptKeyToken = async (KeyToken) =>{
    const {data} = await http.get("/KeyToken/Desencrypt",{ params : {KeyToken:KeyToken}}).catch((error) => ValidatorError(error));
    return data;
}



export const EncryptKeyToken = async (KeyToken) =>{
    const {data} = await http.get("/KeyToken/Encrypt",{ params : {KeyToken:KeyToken}}).catch((error) => ValidatorError(error));
    return data;
}
